module.exports = __webpack_public_path__ + "static/media/298111.964e8bd8.png";